<section *ngIf="loading == false" class="w-full flex flex-column gap-2">
    
    <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="true"></p-steps>
  
    <div class="stepper-content mt-3 p-4 surface-border border-round background-color-secondary">
        <div *ngIf="activeIndex === 0">
            <split-withdrawal-balance (onAvailableWithdrawalChanges)="onAvailableForWithdrawalChange($event)" recipient="{{recipient}}"></split-withdrawal-balance>
            <div class="warning-text mb-2">
                <i class="pi pi-clock"></i>
                <span class="left">
                    O valor "a liquidar" está em processamento (D+2)
                    <strong>e não pode ser sacado agora.</strong>
                </span>
            </div>
            <div class="flex flex-column gap-2">
                <div class="mt-4 fee-card">
                    <div class="flex flex-column gap-1 w-full mb-2">
                        <span class="font-semibold">
                            Quanto deseja sacar?
                        </span>
                        <small class="text-color-secondary">
                            Mínimo R$ 10,00 · Máximo
                            {{ availableForWithdrawal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                        </small>
                    </div>
                    <div class="w-full">
                        <p-inputNumber
                            mode="currency"
                            currency="BRL"
                            locale="pt-BR"
                            placeholder="R$ 0,00"
                            [(ngModel)]="withdrawValue"
                            styleClass="w-full"
                            [max]="availableForWithdrawal"
                            [min]="10"
                        ></p-inputNumber>
                        <div class="mt-1 text-sm text-red-500" *ngIf="withdrawValue !== null && withdrawValue !== undefined">
                            <small *ngIf="withdrawValue < 10">
                                Valor mínimo para saque é R$ 10,00
                            </small>
                            <small *ngIf="withdrawValue > availableForWithdrawal">
                                Valor superior ao saldo disponível
                            </small>
                        </div>
                    </div>
                </div>
                <div class="fee-card warning-text">
                    <i class="pi pi-shield"></i>
                    <span class="fee-label">Taxa de</span>
                    <strong>R$ 3,67</strong>
                    <span>será descontada. Saques frequentes aumentam seu custo.</span>
                </div>
            </div>
        </div>

        <div *ngIf="activeIndex === 1">
            <div class="flex flex-column withdraw-summary mb-3">
                <div class="flex flex-column">
                    <div class="summary-row flex justify-content-between align-items-center px-4 py-3">
                        <span class="label">Valor solicitado</span>
                        <span><strong>R$ {{ withdrawValue | number:'1.2-2' }}</strong></span>
                    </div>
                    <div class="summary-row flex justify-content-between align-items-center px-4 py-3">
                        <span class="label">Taxa de saque (TED)</span>
                        <span class="fee">- R$ {{ withdrawalFee | number:'1.2-2' }}</span>
                    </div>
                    <div class="summary-row total flex justify-content-between align-items-center px-4 py-3">
                        <span class="label">Você receberá</span>
                        <span class="received">R$ {{ amountReceived | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>
            <div class="flex flex-column withdraw-summary">
                <div class="summary-row total flex justify-content-between align-items-center px-4 py-2">
                    <span class="label">
                        <div class="flex align-items-center gap-3">
                            <div class="bank-icon">
                                <i class="pi pi-home"></i>
                            </div>
                            <div class="flex flex-column">
                                <strong>{{ bankName }}</strong>
                                <span>
                                    Ag. {{ bankBranch }} · Conta {{ bankAccount }}
                                </span>
                            </div>
                        </div>
                    </span>
                </div>
            </div>  
            <div class="mt-5 warning-text">
                <i class="pi pi-clock"></i>
                <span>
                    Saques solicitados após 15h serão processados no próximo dia útil.
                </span>
            </div>  
        </div>

        <div *ngIf="activeIndex === 2">
            <ng-container *ngIf="withdrawResult === 'success'">
                <div class="flex justify-content-center step">            
                    <i class="pi pi-check circle" style="color: white; background-color: #28a745;"></i>
                </div>
                <div class="text-center">
                    <h2 class="success-title mb-1">Saque solicitado!</h2>
                    <p class="mt-0">
                        Seu saque foi processado com sucesso.
                        <br>
                        A transferência será creditada em até
                        <strong>1 dia útil.</strong>
                    </p>
                </div>
                <div class="withdraw-summary total py-3">
                    <div class="flex justify-content-between align-items-center px-3 py-1">
                        <span class="label">Valor solicitado</span>
                        <span>{{ withdrawValue | currency:'BRL' }}</span>
                    </div>
                    <div class="flex justify-content-between align-items-center px-3 py-1">
                        <span class="label">Taxa cobrada</span>
                        <span class="fee">
                            - {{ withdrawalFee | currency:'BRL' }}
                        </span>
                    </div>
                    <div class="flex justify-content-between align-items-center px-3 py-1">
                        <span class="label">Você receberá</span>
                        <span class="received">
                            {{ amountReceived | currency:'BRL' }}
                        </span>
                    </div>
                    <div class="flex justify-content-between align-items-center px-3 py-1">
                        <span class="label">Conta destino</span>
                        <strong>
                            {{ bankName }} • Ag.{{ bankBranch }} • {{ bankAccount }}
                        </strong>
                    </div>
                    <div class="flex justify-content-between align-items-center px-3 py-1">
                        <span class="label">Protocolo</span>
                        <strong>
                        {{ protocol }}
                        </strong>
                    </div>
                    <div class="flex justify-content-between align-items-center px-3 py-1">
                        <span class="label">Solicitado em</span>
                        <strong>
                            {{ requestedAt | date:'dd/MM/yyyy HH:mm:ss' }}
                        </strong>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="withdrawResult === 'error'">
                <div class="flex justify-content-center step mb-4">
                    <i class="pi circle flex align-items-center justify-content-center bg-red-500 text-white border-circle
                    "[ngClass]="'pi-times'"></i>
                </div>
                <div class="text-center">
                    <h2 class="success-title mb-1">Saque não processado</h2>
                </div>
                <div class="warning-text flex flex-column align-items-center gap-3">
                    <span>
                        Ocorreu um erro. Tente novamente ou entre em contato com o suporte.
                    </span>
                    <span>    
                        <strong class="text-red-500">
                            Nenhum valor foi debitado do seu saldo.
                        </strong>
                    </span>
                    <span>
                        Erro: {{ errorMessage }}
                    </span>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="flex mt-4" 
        [ngClass]="{
            'justify-content-center': activeIndex === items.length - 1 && withdrawResult === 'success',
            'justify-content-between': activeIndex !== items.length - 1|| (activeIndex === items.length - 1 && withdrawResult === 'error')
        }">
        
        <button 
            *ngIf="activeIndex !== items.length - 1" 
            pButton 
            label="Voltar" 
            icon="pi pi-angle-left" 
            (click)="previousStep()" 
            [disabled]="activeIndex === 0"
            class="p-button-secondary">
        </button>
        <button 
            *ngIf="activeIndex == 0" 
            pButton 
            label="Avançar" 
            icon="pi pi-angle-right" 
            iconPos="right" 
            (click)="nextStep()"
            [disabled]="isValueValid == false"
            >
        </button>
        <button 
            *ngIf="activeIndex == 1" 
            pButton 
            label="Solicitar saque" 
            icon="pi pi-angle-right" 
            iconPos="right" 
            (click)="confirmAndGoToStep3()"
            [disabled]="isWithdrawalValid == false"
            >
        </button>
        <button 
            *ngIf="activeIndex === items.length - 1 && withdrawResult === 'error'" 
            pButton 
            label="Tentar novamente" 
            icon="pi pi-refresh"
            (click)="resetToInitialStep()"
            class="p-button-primary">
        </button>
        <button 
            *ngIf="activeIndex === items.length - 1" 
            pButton 
            label="Finalizar" 
            iconPos="bottom" 
            (click)="close()"
            class="p-button-success">
        </button>
    </div>
</section>

<section *ngIf="loading" class="w-full flex flex-column gap-2"> 
    <div class="loading">
        <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
</section>
